import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import { programs } from "@/mocks/skincare";

export default function Programs() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100/60">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Programs"
          title="비앙카 피부관리 프로그램"
          description="피부 고민별로 세분화된 6가지 전문 프로그램으로, 고객님의 피부에 꼭 맞는 관리를 제공합니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program) => (
            <Link
              key={program.id}
              to="/programs"
              className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full h-60 overflow-hidden">
                <img
                  src={program.image}
                  alt={`${program.name} 피부관리 프로그램`}
                  title={`${program.name} - 비앙카 피부관리`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                  {program.duration}
                </span>
              </div>
              <div className="flex flex-col gap-2 p-5">
                <span className="text-[11px] font-medium tracking-[0.15em] uppercase text-primary-500">
                  {program.english}
                </span>
                <h3 className="text-lg font-bold text-foreground-900">{program.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{program.description}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                  자세히 보기
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}